.mainContainer {
	display: flex;
	flex-direction: column;
	width: 100%;
	padding: 30px;
	gap: 30px;
}
